import { combineReducers } from 'redux';
import { itemCriteriaReducer } from './ItemCriteriaReducer';

export default combineReducers({
  itemCriteria: itemCriteriaReducer,
});
